import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import {
  cadastrarCondicaoComercial,
  atualizarCondicaoComercial,
  excluirCondicaoComercial,
  buscarFaturamentosPorGrupoEconomico,
  obterFaturasPorCampo,
} from "../../services/api-financeiro.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "../../config/AuthContext";
import CondicaoComercialForm from "src/forms/CondicaoComercialForm";
import { FaturamentoContext } from "./FaturamentoContext";
import ViewExportPdf from "./ViewExportPdf";
import generatePDF, { Resolution } from "react-to-pdf";
import { getPageSliceHeightLayoutPx } from "../../utils/reactToPdfSlice.util";

const Faturamento = () => {
  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [msg, setMsg] = useState("");
  const { setDados } = useContext(FaturamentoContext);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idCnpj, setIdCnpj] = useState(null);

  const [exportFilename, setExportFilename] = useState("");
  const [exportData, setExportData] = useState([]);

  const [msgTable, setMsgTable] = useState(null);

  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const formRef = useRef();
  const pdfFooterTotalRef = useRef(null);

  const columns = [
    { id: "cnpj", label: "CNPJ", field: "cnpj" },
    { id: "servico", label: "Serviço", field: "servico" },
    { id: "dtFatura", label: "Dt. Fatura", field: "dtFatura" },
    {
      id: "percentualHonorarios",
      label: "Percentual Honorarios",
      field: "percentualHonorarios",
      type: "porcentagem",
    },
    { id: "imposto", label: "Imposto", field: "imposto", type: "porcentagem" },
    {
      id: "valorFatura",
      label: "Vl. Fatura",
      field: "valorFatura",
      type: "monetario",
    },
    {
      id: "valorFinalHonorario",
      label: "Vl. Final Honorario",
      field: "valorFinalHonorario",
      type: "monetario",
    },
    { id: "valorIR", label: "Valor IR", field: "valorIR", type: "monetario" },
    {
      id: "valorCofins",
      label: "Pis/Cofins",
      field: "valorCofins",
      type: "monetario",
    },
    {
      id: "valorCsll",
      label: "Vl. Csll",
      field: "valorCsll",
      type: "monetario",
    },
    { id: "boleto", label: "Boleto", field: "boleto", type: "monetario" },
    {
      id: "historicoFatura",
      label: "Histórico Fatura",
      field: "historicoFatura",
    },
  ];

  useEffect(() => {
    setDados(dataFilter);
  }, [dataFilter]);

  const compareDatesIgnoringTime = (date1, date2) => {
    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    if (d1.getTime() === d2.getTime()) {
      return 0;
    } else if (d1.getTime() > d2.getTime()) {
      return 1;
    } else {
      return -1;
    }
  };

  const applyDateRangeFilter = (data) => {
    let faturamentos = data;

    if (dateStart && dateStart instanceof Date && dateStart !== null) {
      faturamentos = data.filter((item) => {
        return compareDatesIgnoringTime(item.dtFatura, dateStart) >= 0;
      });
    }

    if (dateEnd && dateEnd instanceof Date && dateEnd !== null) {
      faturamentos = faturamentos.filter((item) => {
        return compareDatesIgnoringTime(item.dtFatura, dateEnd) <= 0;
      });
    }

    // faturamentos = faturamentos.map((item) => {
    //   return {
    //     ...item,
    //     valorCofins: parseInt(item.valorCofins) + parseInt(item.valorPis),
    //   };.
    // });
    return faturamentos;
  };

  useEffect(() => {
    if (idCnpj?.length > 0) {
      let faturamentos = data.filter((item) =>
        idCnpj.includes(item.idEmpresa.toString())
      );
      faturamentos = applyDateRangeFilter(faturamentos);
      setDataFilter(faturamentos);
      setExportData(setupExportData(faturamentos));
    } else {
      let faturamentos = applyDateRangeFilter(data);
      setDataFilter(faturamentos);
      setExportData(setupExportData(faturamentos));
    }
  }, [idCnpj, dateStart, dateEnd]);

  useEffect(() => {
    const fetchData = async () => {
      if (idGrupoEconomico) {
        setMsgTable(null);
        await getData(idGrupoEconomico);
      } else {
        setMsgTable("Por favor, selecione o grupo econômico.");
        setIdGrupoEconomico(0);
        await getData(0);
      }
    };
    fetchData();
  }, [idGrupoEconomico]);

  const handleOpenModal = async (rowData) => {
    rowData.validoDe = new Date(rowData.validoDe);
    rowData.validoAte = new Date(rowData.validoAte);
    rowData.idCondicaoComercial !== undefined
      ? setEditRowData(rowData)
      : setEditRowData({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    data.condicaoComercial.idGrupoEconomico = parseInt(idGrupoEconomico);
    if (!editRowData.idCondicaoComercial) {
      await cadastrarCondicaoComercial(data)
        .then(async (response) => {
          setMsg(response.mensagem);
          await getData();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    } else {
      await atualizarCondicaoComercial(
        {
          data,
        },
        parseInt(editRowData.idCondicaoComercial)
      )
        .then(async (response) => {
          setMsg(response.mensagem);
          await getData();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    }

    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    await excluirCondicaoComercial(editRowData.idCondicaoComercial)
      .then(async (response) => {
        setMsg(response.mensagem);
        await getData();
        handleCloseDialogExclusao();
        handleOpenSnackbarSucesso();
      })
      .catch((err) =>
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      );
    setLoading(false);
  };

  const getData = async (idGrupoEconomicoParam) => {
    try {
      const response = await buscarFaturamentosPorGrupoEconomico(
        idGrupoEconomicoParam
      );

      let faturamentos = response.faturamentos;

      faturamentos = await faturamentos.map((faturamento) => {
        faturamento.valorCofins =
          Number(faturamento.valorCofins) + Number(faturamento.valorPis);
        faturamento.valorIR = handleCalculaIR(
          faturamento.valorFatura,
          faturamento.percentualHonorarios,
          faturamento.imposto
        );
        faturamento.boleto = handleCalculaBoleto(
          faturamento.valorFinalHonorario,
          faturamento.valorIR,
          faturamento.valorCofins,
          faturamento.valorCsll
        );
        if (faturamento.dtFatura) {
          faturamento.dtFatura = new Date(faturamento.dtFatura);
          faturamento.dtFatura.setHours(faturamento.dtFatura.getHours() + 3);
        }
        return faturamento;
      });

      faturamentos = applyDateRangeFilter(faturamentos);

      setExportData(setupExportData(faturamentos));
      setExportFilename(getExportFilename(idGrupoEconomico));

      setData(faturamentos);
      setDataFilter(faturamentos);
    } catch (err) {
      console.log(err);

      setMsg(err.mensagem);
      handleOpenSnackbarErro();
    }
  };

  const handleCalculaIR = (valor, percentual, imposto) => {
    if (valor && percentual && imposto) {
      const calculo =
        Math.round(
          ((valor * (percentual / 100)) / ((100 - imposto) / 100)) *
            (1.5 / 100) *
            100
        ) / 100;
      return calculo < 10 ? 0 : calculo.toFixed(2);
    } else {
      return 0;
    }
  };

  const handleCalculaBoleto = (vlHonorario, ir, cofins, csll) => {
    const VH = Number(vlHonorario);
    const IR = Number(ir);
    const CF = Number(cofins);
    const CL = Number(csll);
    const calculo = ((VH - IR ?? 0) - CF ?? 0) - CL ?? 0;
    return calculo.toFixed(2);
  };

  const getExportFilename = (idGrupoEconomico) => {
    return "faturamento_idGrupo_"
      .concat(idGrupoEconomico)
      .concat("_")
      .concat(
        new Date()
          .toISOString()
          .replace(/\.\d{3}/, "")
          .replace("T", " ")
          .replace("Z", "")
          .replaceAll(":", "-")
          .replace(" ", "_")
      );
  };

  const setupExportData = (faturamentos) => {
    var exportData = [];
    var exportDataSums = {
      "<style bold>Grupo Econômico</style>":
        "<style bold>Total Grupo Econômico</style>",
      "<style bold>Razão Social</style>": 0,
      "<style bold>Serviço</style>": "",
      "<style bold>Dt. Fatura</style>": "",
      "<style bold>Percentual Honorarios</style>": 0,
      "<style bold>Imposto</style>": 0,
      "<style bold>Valor Fatura</style>": 0,
      "<style bold>Valor Final Honorario</style>": 0,
      "<style bold>Valor Cofins</style>": 0,
      "<style bold>Valor Csll</style>": 0,
      "<style bold>Histórico Fatura</style>": "",
    };

    faturamentos.forEach((faturamento) => {
      exportData.push({
        "<style bold>Grupo Econômico</style>": faturamento.grupoEconomico,
        "<style bold>Razão Social</style>": faturamento.razaoSocial,
        "<style bold>Serviço</style>": faturamento.servico,
        "<style bold>Dt. Fatura</style>": faturamento.dtFatura,
        "<style bold>Percentual Honorarios</style>": Number(
          faturamento.percentualHonorarios
        ),
        "<style bold>Imposto</style>": Number(faturamento.imposto),
        "<style bold>Valor Fatura</style>": Number(faturamento.valorFatura),
        "<style bold>Valor Final Honorario</style>": Number(
          faturamento.valorFinalHonorario
        ),
        "<style bold>Valor Cofins</style>": Number(faturamento.valorCofins),
        "<style bold>Valor Csll</style>": Number(faturamento.valorCsll),
        "<style bold>Histórico Fatura</style>": faturamento.historicoFatura,
      });
      exportDataSums["<style bold>Razão Social</style>"] += parseFloat(
        faturamento.valorFatura.replace("R$", "").replace(".", "")
      );
    });

    exportData.push({
      "<style bold>Grupo Econômico</style>": "Total Grupo Econômico</style>",
      "<style bold>Razão Social</style>": exportDataSums[
        "<style bold>Razão Social</style>"
      ]
        .toFixed(2)
        .replace(".", ","),
      "<style bold>Serviço</style>": "",
      "<style bold>Dt. Fatura</style>": "",
      "<style bold>Percentual Honorarios</style>": 0,
      "<style bold>Imposto</style>": 0,
      "<style bold>Valor Fatura</style>": 0,
      "<style bold>Valor Final Honorario</style>": 0,
      "<style bold>Valor Cofins</style>": 0,
      "<style bold>Valor Csll</style>": 0,
      "<style bold>Histórico Fatura</style>": 0,
    });
    return exportData;
  };

  useEffect(() => {
    if (idGrupoEconomico === 0 || !idGrupoEconomico)
      setMsgTable("Por favor, selecione o grupo econômico.");
    else setMsgTable(null);
  });

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleLoginChange = (event) => {
    const loginValue = event.target.value
      .replace(/\s+/g, ".")
      .replace(/[^a-zA-Z.]/g, "")
      .replace(/\.+/g, ".")
      .toLowerCase();
    setEditRowData({ ...editRowData, login: loginValue });
  };

  const handleDebouncerChange = async (event) => {
    if (idGrupoEconomico === 0 || !idGrupoEconomico) {
      setMsg("Antes de filtrar, selecione o grupo econômico.");
      handleOpenSnackbarErro();
      return;
    }
    setLoading(true);
    try {
      const response = await obterFaturasPorCampo(
        event.target.value,
        idGrupoEconomico
      );
      let faturamentos = response.faturamentos;
      faturamentos = await faturamentos.map((faturamento) => {
        faturamento.valorIR = handleCalculaIR(
          faturamento.valorFatura,
          faturamento.percentualHonorarios,
          faturamento.imposto
        );
        faturamento.boleto = handleCalculaBoleto(
          faturamento.valorFinalHonorario,
          faturamento.valorIR,
          faturamento.valorCofins,
          faturamento.valorCsll
        );
        if (faturamento.dtFatura) {
          faturamento.dtFatura = new Date(faturamento.dtFatura);
          faturamento.dtFatura.setHours(faturamento.dtFatura.getHours() + 3);
        }
        faturamento.valorCofins =
          parseInt(faturamento.valorCofins) + parseInt(faturamento.valorPis);
        return faturamento;
      });

      setExportData(setupExportData(faturamentos));
      setExportFilename(getExportFilename(idGrupoEconomico));

      setData(faturamentos);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setData([]);
      } else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      }
    }
    setLoading(false);
  };

  const handleGrupoECnpjChange = async (ids) => {
    if (ids.GE) {
      setMsgTable(null);
      idGrupoEconomico !== ids.GE && setIdGrupoEconomico(ids.GE);
      idCnpj !== ids.CNPJ && setIdCnpj(ids.CNPJ);
      // await getData(ids.GE, ids.CNPJ);
    } else {
      setMsgTable("Por favor, selecione o grupo econômico.");
      setIdGrupoEconomico(0);
      await getData(0);
    }
  };
  const [openPreviaPDF, setOpenPreviaPDF] = useState(false);

  const handleClosePreviaPDF = () => {
    setOpenPreviaPDF(false);
  };
  const handleOpenPreviaPDF = () => {
    setOpenPreviaPDF(true);
  };

  const getTargetElement = () => formRef.current;

  const handleExportPDF = async () => {
    const baseOptions = {
      method: "save",
      resolution: Resolution.MEDIUM,
      filename: `Resumo_${dataFilter[0]?.grupoEconomico}.pdf`,
      page: {
        margin: 10,
        format: "a4",
        orientation: "portrait",
      },
    };

    const root = formRef.current;
    const runGenerate = () => generatePDF(getTargetElement, baseOptions);

    if (!root) {
      await runGenerate();
      return;
    }

    await new Promise((resolve) => requestAnimationFrame(resolve));

    const slice = getPageSliceHeightLayoutPx({
      format: baseOptions.page.format,
      orientation: baseOptions.page.orientation,
      margin: baseOptions.page.margin,
      captureWidthPx: root.getBoundingClientRect().width,
    });

    const avoidBreakEls = Array.from(root.querySelectorAll("[data-pdf-avoid-break]"));
    const previousMargins = avoidBreakEls.map((el) => el.style.marginTop);

    if (slice > 0) {
      const rootTop = root.getBoundingClientRect().top;
      for (const el of avoidBreakEls) {
        const rect = el.getBoundingClientRect();
        const top = rect.top - rootTop;
        const bottom = rect.bottom - rootTop;
        const blockHeight = bottom - top;

        if (blockHeight >= slice - 1e-3) continue;

        const firstSlice = Math.floor((top + 1e-3) / slice);
        const lastSlice = Math.floor((bottom - 1e-3) / slice);
        if (firstSlice === lastSlice) continue;

        const pushTo = (firstSlice + 1) * slice;
        const extra = Math.max(0, pushTo - top);
        if (extra > 0) {
          el.style.marginTop = `${(parseFloat(el.style.marginTop) || 0) + extra}px`;
        }
      }
    }

    await new Promise((resolve) => requestAnimationFrame(resolve));

    try {
      await runGenerate();
    } finally {
      avoidBreakEls.forEach((el, i) => {
        el.style.marginTop = previousMargins[i];
      });
    }
  };

  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  };

  const handleDateRangeChange = (val, dateType) => {
    if (dateType === "start") {
      setDateStart(isValidDate(val) ? val : null);
    } else if (dateType === "end") {
      setDateEnd(isValidDate(val) ? val : null);
    }
  };

  return (
    <div>
      <Dialog
        open={openPreviaPDF}
        onClose={handleClosePreviaPDF}
        fullScreen
        sx={{ padding: 0 }}
      >
        <ViewExportPdf
          reference={formRef}
          footerTotalRef={pdfFooterTotalRef}
          exportPDF={handleExportPDF}
          onClose={handleClosePreviaPDF}
        />
      </Dialog>
      <Main />

      <CRUDPageHeader
        headerIcon={<TrendingUpIcon fontSize="30px" />}
        headerTitle={"Faturamento"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        AutoCompleteGrupoECnpj
        multipleCnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
        handleDateRange={handleDateRangeChange}
        labelDateRangeStart="Data Inicial"
        labelDateRangeEnd="Data Final"
        dateRangePicker
        disableModalButton
        disableSearch
      />
      <TabelaDinamica
        data={dataFilter}
        columns={columns}
        loading={loading}
        orderColumn={"idCondicaoComercial"}
        disableEdit
        disableDelete
        exportFilename={exportFilename}
        exportData={exportData}
        msgTable={msgTable}
        functionExportPDF={handleOpenPreviaPDF}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <TrendingUpIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idCondicaoComercial
                ? "Edição de Condição Comercial"
                : "Cadastro de Condição Comercial"}
            </h1>
          </div>
        </DialogTitle>
        <CondicaoComercialForm
          condicaoComercialValues={Object.assign({}, editRowData)}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        ></CondicaoComercialForm>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente a condição comercial{" "}
            {editRowData.idCondicaoComercial}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Faturamento;
